// extracted by mini-css-extract-plugin
export default {"layer":"hand-pose_layer__YQYS7"};